<template>
  <v-card class="elevation-12">
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title>Все договора</v-toolbar-title>
      <v-spacer/>
    </v-toolbar>

    <v-data-table :items="items" :headers="headers">
      <template v-slot:item.actions="{item}">
        <v-btn v-if="item.executor.company_inn === $store.getters.companyInn && !item.executor.on_wait" :to="{name: 'view-contract', params: {id: item.id}}" text small color="primary">
          Ждем Ваших действий
        </v-btn>
        <v-btn v-else :to="{name: 'view-contract', params: {id: item.id}}" text small color="primary">
          Открыть
        </v-btn>
      </template>
      <template v-slot:item.contractor="{item}">
        <span v-if="isExecutor(item)">
          ({{ item.customers[0].company_inn }}) {{ item.customers[0].company_name }}
        </span>
        <span v-else-if="isCustomer(item)">
          ({{ item.executor.company_inn }}) {{ item.executor.company_name }}
        </span>
      </template>

      <template v-slot:no-data>
        По Вашему запросу данных не найдено
      </template>
      <template v-slot:top="scope">
        <v-sheet color="grey lighten-3" class="px-4 pt-4 pb-3" tile>
          <h3 class="transition-swing font-weight-medium">Фильтрация</h3>

          <v-responsive>
            <v-row>
              <v-col cols="12" sm="6" md="3" class="py-2">
                <select-company v-model="filters.company" :dense="true" :hide-details="true" label="Контрагент" :clearable="true"/>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-2">
                <v-text-field v-model="filters.number" :dense="true" :hide-details="true" label="Номер" outlined/>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-2">
                <DateInput v-model="filters.date" :dense="true" :hide-details="true" label="Дата" outlined/>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-2">
                <v-autocomplete v-model="filters.isExecutorApproved" :items="isExecutorApprovedOptions" label="Подтверждён поставщиком" :hide-details="true" :dense="true" outlined/>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-2">
                <v-autocomplete v-model="filters.isCustomerApproved" :items="isCustomerApprovedOptions" label="Подтверждён заказчиком" :hide-details="true" :dense="true" outlined/>
              </v-col>
            </v-row>
          </v-responsive>
        </v-sheet>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import ContractService from '@/services/contract.service'
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import _ from 'underscore'
import DateInput from "@/components/Input/DateInput";
import SelectCompany from "@/components/Select/SelectCompany";

export default {
  name: "ContractAllBoxView",
  components: {
    SelectCompany,
    DateInput
  },
  data: () => ({
    contracts: [],
    filters: {
      isExecutorApproved: null,
      isCustomerApproved: null,
      number: '',
      date: null,
      company: null
    },
    isExecutorApprovedOptions: [
      {text: 'Да', value: true},
      {text: 'Нет', value: false},
      {text: 'Неважно', value: null}
    ],
    isCustomerApprovedOptions: [
      {text: 'Да', value: true},
      {text: 'Нет', value: false},
      {text: 'Неважно', value: null}
    ],
  }),
  computed: {
    headers() {
      return [
        {text: 'Номер', value: 'number'},
        {text: 'Дата', value: 'date'},
        {text: 'Наименование', value: 'title'},
        {text: 'Действителен до', value: 'expires_on'},
        {text: 'Контрагент', value: 'contractor'},
        {text: 'Дата создания', value: 'created_at'},
        {text: '', value: 'actions', align: 'right'}
      ]
    },
    items() {
      let items = _.map(this.contracts, c => {
        return c
      })

      if (this.filters.isExecutorApproved !== null)
        items = _.filter(items, item => {
          return item.executor.is_approved === this.filters.isExecutorApproved
        })

      if (this.filters.isCustomerApproved !== null)
        items = _.filter(items, item => {
          return item.customers[0].is_approved === this.filters.isCustomerApproved
        })

      if (this.filters.number.length) {
        let pieces = _.filter(this.filters.number.split(' '), p => {
          return p.length > 0;
        });
        items = _.filter(items, item => {
          return _.every(pieces, p => {
            return item.number.toString().toLocaleUpperCase().indexOf(p.toLocaleUpperCase()) !== -1;
          });
        })
      }

      if (this.filters.date)
        items = _.filter(items, item => {
          return item.date === this.filters.date.format('YYYY-MM-DD')
        })

      if (this.filters.company)
        items = _.filter(items, item => {
          if (this.isExecutor(item)) {
            return item.customers[0].company_inn === this.filters.company.inn
          } else if (this.isCustomer(item)) {
            return item.executor.company_inn === this.filters.company.inn
          }

          return true
        })

      return items
    }
  },
  methods: {
    load() {
      this.$store.dispatch(LAYOUT_LOADING_START)
      ContractService.getDraftContractAll()
          .then(response => {
            this.contracts = response.data
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    isExecutor(contract) {
      return contract.executor.company_inn === this.$store.getters.login.company.inn
    },
    isCustomer(contract) {
      return contract.customers[0].company_inn === this.$store.getters.login.company.inn
    },
  },
  created() {
    this.load()
  },
}
</script>

<style scoped>

</style>